<template>
	<div class="dashboard-wrapper">
		<div class="card">
			<div class="card-body">
				<ul class="nav nav-tabs">
					<li class="nav-item">
						<a class="nav-link" :class="{ active: activeTab === 'Checklist' }"
							@click="activeTab = 'Checklist'"> Checklist
						</a>
					</li>
					<li class="nav-item">
						<a class="nav-link" :class="{ active: activeTab === 'SAPOrders' }"
							@click="activeTab = 'SAPOrders'"> SAP Orders
						</a>
					</li>
					<li class="nav-item" v-if="isSuperAdmin">
						<a class="nav-link" :class="{ active: activeTab === 'FalseAir' }"
							@click="activeTab = 'FalseAir'"> False Air
						</a>
					</li>
				</ul>
				<div class="tab-content-wrapper">
					<component :is="activeComponent" v-bind="checklistOnlyProps" />
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import Checklist from '@/components/Checklist.vue'
import SAPOrders from '@/components/SAPorders.vue'
import FalseAir from '@/components/FalseAir.vue'

export default {
	name: 'Dashboard',
	components: {
		Checklist,
		SAPOrders,
		FalseAir,
	},
	data() {
		return {
			activeTab: 'Checklist',
		}
	},
	computed: {
		isSuperAdmin() {
			return this.$store.getters.user?.role?.role_name === 'Super Admin'
		},
		activeComponent() {
			if (this.activeTab === 'FalseAir' && !this.isSuperAdmin) {
				return 'Checklist'
			}
			return this.activeTab
		},
		isAkxaPlantChecklistFrontendOnly() {
			const u = this.$store.getters.user
			if (!u) {
				return false
			}
			let code = ''
			if (u.plant && u.plant.plant_code) {
				code = u.plant.plant_code
			} else if (u.plant_code) {
				code = u.plant_code
			}
			return String(code).trim().toUpperCase() === 'AKXA'
		},
		checklistOnlyProps() {
			if (this.activeComponent !== 'Checklist') {
				return {}
			}
			return {
				akxaChecklistNoApi: this.isAkxaPlantChecklistFrontendOnly,
			}
		},
	},
	watch: {
		isSuperAdmin(ok) {
			if (!ok && this.activeTab === 'FalseAir') {
				this.activeTab = 'Checklist'
			}
		},
	},
	mounted() {
		document.body.style.overflow = 'hidden';
	},
	beforeUnmount() {
		document.body.style.overflow = '';
	},
}
</script>

<style scoped>
.dashboard-wrapper {
	height: 100%;
	display: flex;
	flex-direction: column;
	overflow: hidden;
	position: relative;
	z-index: 100;
}

.dashboard-wrapper .card {
	flex: 1;
	display: flex;
	flex-direction: column;
	overflow: hidden;
	margin: 0;
	min-height: 0;
	height: 100%;
}

.dashboard-wrapper .card-body {
	flex: 1;
	display: flex;
	flex-direction: column;
	overflow: hidden;
	padding: 15px;
	min-height: 0;
}

.dashboard-wrapper .nav-tabs {
	flex-shrink: 0;
	margin-bottom: 0;
	border-bottom: 2px solid #e1e8f3;
	padding-left: 0;
	padding-right: 0;
	background-color: #f8f9fa;
	border-top-left-radius: 8px;
	border-top-right-radius: 8px;
}

.dashboard-wrapper .nav-tabs .nav-item {
	margin-bottom: -2px;
}

.dashboard-wrapper .nav-tabs .nav-link {
	padding: 12px 24px;
	border: none;
	border-bottom: 3px solid transparent;
	color: #5e6973;
	font-weight: 500;
	font-size: 0.95rem;
	cursor: pointer;
	transition: all 0.3s ease;
	background-color: transparent;
	border-radius: 0;
	margin-right: 4px;
}

.dashboard-wrapper .nav-tabs .nav-link:hover {
	color: #1273eb;
	background-color: rgba(18, 115, 235, 0.05);
	border-bottom-color: rgba(18, 115, 235, 0.3);
}

.dashboard-wrapper .nav-tabs .nav-link.active {
	color: #1273eb;
	background-color: #ffffff;
	border-bottom: 3px solid #1273eb;
	font-weight: 600;
	box-shadow: 0 -2px 4px rgba(0, 0, 0, 0.05);
}

.tab-content-wrapper {
	flex: 1;
	overflow-y: auto;
	overflow-x: hidden;
	margin-top: 15px;
	min-height: 0;
	position: relative;
	-webkit-overflow-scrolling: touch;
}
</style>
